export const getKey = (state) => (key) => {
    const lang = state.translations.lang;
    
    return state.translations.keys[lang][key] || key;
};